export const ENTER_KEY_CODE = 13;
export const SPACE_KEY_CODE = 32;
export const UP_ARROW_KEY_CODE = 38;
export const DOWN_ARROW_KEY_CODE = 40;
export const FIRST_LETTER_KEY_CODE = 65;
export const LAST_LETTER_KEY_CODE = 122;
